<template>
  <div
    class="GoodsItem"
    @click="onAllClick(goods)"
  >
    <div
      class="imgBox"
      @click="onClick(goods,categoryName)"
    >
      <img
        :src="goods.imgGuide || goods.goodsImage"
        alt
      />
      <img
        v-if="goods.bizStock === 0"
        class="soldOut"
        :src="require('@assets/images/allGone.png')"
        alt
      />
      <Sticker
        v-if="goods.goodsType !== 1"
        :imgList="goods.stickerImgList"
      />
      <div
        v-if="goods.advanceSale"
        :class="[
          'desContent-active',
          'flex',
          union_isBilingual || CookiesOne && CookiesOne == 'en-US' ? 'isBilingual' : '',
        ]"
      >
        <div :class="{ 'presell-time': true }">
          {{ TLang('起发货1','my') }}{{
            new Date(goods.sendGoodsTimeStart)
              .toLocaleDateString()
              .replace(/\//g, "-")
          }}{{ TLang('起发货2','my') }}
        </div>
      </div>
      <!-- 爆炸贴图片 -->
      <!-- <Sticker v-if="goods.goodsType !== 1" :imgList="goods.stickerImgList" /> -->
      <div
        v-if="
          (goods.gray ||
            (restock && typeof goods.stockNum === 'number' && goods.stockNum === 0)) &&
            goods.bizStock === null
        "
        class="restock"
      >
        <img src="./restock.png" />
      </div>
    </div>
    <a
      class="goods-name line-clamp-2"
      :title="goods.goodsName || goods.name"
    >
      <i
        v-for="(tag, index) in goods.tags"
        :key="index"
        :style="{ fontStyle: 'normal'}"
      >
        <SingleTag
          :show="tag.mktFrontType === 9005"
          :datas="tag"
        />
      </i>
      {{ goods.goodsName || goods.name }}
    </a>
    <div class="goods-flag">
      <span
        v-for="(tag, index) in goods.tags"
        :key="index"
        class="goods-item-flag"
      >
        <SingleTag
          :show="tagShow(tag, true)"
          :datas="tag"
        />
      </span>
    </div>
    <div
      v-if="goods && goods.groupItem === 'Y'"
      class="fpp-style"
    >
      <FppGoodsPrice
        :type="goods.groupItemClassStyle"
        :price="goods.groupItemPrice"
        :limitPrice="goods.groupItemPriceLimit"
        :unionIcon="union_icon || require('@assets/images/fudou.png')"
        :showSymbolIcon="goods.groupItemShowRmbSymbol"
      />
    </div>
    <div
      v-if="getBlackPrice() > 0"
      class="discountPriceWrap"
      :class="{'pad-15':goType === 'brandDetail'}"
    >
      <PurplePrice
        :key="goods.goodsId + goods.categoryId"
        :price="getBlackPrice()"
        :unionIcon="union_icon"
        :union_scale="union_scale"
        :showAddBtn="purchaseType === 1 && goods.goodsType !== 1 && goods.bizStock != 0 && goType !== 'brandDetail'"
        :getGoodsInfo="onClickAdd"
        priceStyle="color: #333333"
        type="discount"
        :discount="goods.discountTagShow == 1 ? goods.discount : 0"
      />
    </div>
    <div
      v-if="goods && goods.groupItem !== 'Y'"
      :class="[
        getRedPurplePrice() > 0 ? 'row-price' : '',
        goods.tags && goods.tags.length > 0 ? 'market-row-price' : '',
      ]"
    >
      <PurplePrice
        v-if="getRedPurplePrice() > 0"
        :key="goods.goodsId + goods.categoryId"
        :price="getRedPurplePrice()"
        :unionIcon="union_icon"
        :union_scale="union_scale"
        :smallPurpleIcon="getPurpleIcon('small')"
        :largePurpleIcon="getPurpleIcon('large')"
        :isShowQi="goods.hasPriceTag"
        :showAddBtn="((goods.dfPriceVo && !goods.dfPriceVo.blackPrice) && !goods.discountPrice) && purchaseType === 1 && goods.goodsType !== 1 && goods.bizStock != 0 && goType !== 'brandDetail'"
        :getGoodsInfo="onClickAdd"
      />
      <div
        v-if="goType === 'brandDetail'"
        class="detail-add-btn"
      >
        {{ TLang('去购买','brand') }}
      </div>
    </div>
    <div
      v-if="getUnderLinePrice() > 0"
      class="line-price-box"
    >
      <img
        v-if="!union_strikethroughPriceIcon"
        :src="union_icon || defaultLineIcon"
        alt=""
        class="fudou2"
        style="filter: grayscale(1);"
      />
      <img
        v-if="union_strikethroughPriceIcon"
        :src="union_strikethroughPriceIcon"
        alt=""
        class="fudou2"
      />
      <span class="line-price-num">
        {{ parseFloat((getUnderLinePrice() * union_scale).toFixed(2)) }}
        <!-- <span v-if="goods.hasPriceTag">{{TLang('起','my')}}</span> -->
      </span>
    </div>
  </div>
</template>

<script>
import Sticker from '@components/sticker';
import SingleTag from '@components/singleTag';
import FppGoodsPrice from '@components/FppGoodsPrice';
import DiscountPrice from '../DiscountPrice';
import PurplePrice from "@/components/purplePrice";
import Cookies from 'js-cookie';
export default {
  components: {
    Sticker,
    DiscountPrice,
    SingleTag,
    FppGoodsPrice,
    PurplePrice,
  },
  props: {
    goods: Object,
    categoryName: String,
    onClick: Function,
    onClickAdd: Function,
    onAllClick: Function,
    goType: String,
    purchaseType: {
      type: Number,
      default: function() {
        return 1;
      },
    },
    restock: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
    page:{
      type:String,
      default:function(){
        return '';
      },
    },
  },

  data() {
    return {
      addIcon:'https://fecdn.dongfangfuli.com/mall/images/mallIcon/icon_cart_h5.png',
      defaultIcon: 'https://fecdn.dongfangfuli.com/mall/images/mallIcon/icon_fudou_h5.png',
      defaultLineIcon: 'https://fecdn.dongfangfuli.com/mall/images/mallIcon/icon_fudou_delete_h5.png',
      defaultPurpleIcon: 'https://fecdn.dongfangfuli.com/mall/images/mallIcon/purple_icon_h5.png',
      CookiesOne:Cookies.get('df_lang'),
    };
  },
  methods: {
    getBlackPrice() {
      return (this.goods.dfPriceVo && this.goods.dfPriceVo.blackPrice) || this.goods.discountPrice || 0
    },
    getRedPurplePrice() {
      if(this.goods && this.goods.dfPriceVo) {
        return this.goods.dfPriceVo.redPrice || this.goods.dfPriceVo.purplePrice || 0
      } else if(this.goods.goodsType != 0) {
        return this.goods.promPrice || this.goods.goodsPrice  || this.goods.price || 0
      }
      return 0
    },
    getUnderLinePrice() {

      if(this.goods && this.goods.dfPriceVo) {
        return this.goods.dfPriceVo.underlinePrice || 0
      } else if(this.goods.goodsType != 0 && this.goods.promPrice > 0 &&  this.goods.tags && this.goods.tags.length > 0) {
        return this.goods.salePrice || this.goods.goodsPrice || this.goods.price || 0
      }
      return 0
    },
    getPurpleIcon(type) {
      if(this.goods && this.goods.tags) {
        const currentItem = this.goods.tags.find(y => y.mktFrontType == 11001);
        if(!currentItem) return
        if(type == 'small') {
          return currentItem.smallIcon || this.defaultPurpleIcon;
        } else if(type == 'large') {
          return currentItem.mktIcon || this.defaultPurpleIcon;
        }
      }
      return null
    },
    tagShow(item, limitFlag) {
      let flag = false;
      // mktIcon 特价、限购、新品 || limitFlag && mktFrontType限购起购 || mktFrontType 300001
      if (item.mktIcon || (limitFlag && (item.mktFrontType === 9003 || item.mktFrontType === 9004))) {
        flag = true;
      }
      return flag;
    },
  },
};
</script>

<style lang="less" scoped>
.GoodsItem {
  // padding: 5px 10px;
  width: 230px;
  overflow: hidden;
  img[lazy="loading"] {
    background: #ededed;
  }
  img[lazy="error"] {
    /*your style here*/
    background: #ededed;
  }
  .imgBox {
    width: 200px;
    height: 200px;
    // padding: 0 15px;
    box-sizing: border-box;
    position: relative;
    margin: 0 auto;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      transition: all 600ms ease;
    }
    .soldOut{
      position: absolute;
      width: 110px;
      height: 110px;
      min-height: auto;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 10
    }
    .restock {
      position: absolute;
      width: 110px;
      height: 110px;
      min-height: auto;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .desContent-active {
      position: absolute;
      bottom: 0;
      width: 100%;
      line-height: 24px;
      color: rgba(255, 255, 255, 1);
      box-sizing: border-box;
      background: url("./../../../assets/images/presale.png");
      background-size: 200px 24px;
      background-repeat: no-repeat;
      .presell-time {
        line-height: 24px;
        text-align: center;
        border-radius: 0px 4px 0px 0px;
        flex: 1;
        white-space: nowrap;
        font-size: 12px;

        margin-left: 60px;
      }
    }
    .isBilingual {
      background-image: url("./../../../assets/images/presale-en.png");
    }
    &:hover img {
      // transition: all 600ms ease;
      // transform: scale(1.2,1.2);
      cursor: pointer;
    }
  }
  .goods-name {
    padding: 0 15px;
    font-size: 14px;
    color: rgba(34, 34, 34, 1);
    line-height: 20px;
    margin-top: 5px;
    height: 40px;
  }
  .row-price {
    padding: 0 15px;
    margin-top: 6px;
    display: flex;
    align-items: center;
    .price-box {
      display: flex;
      align-items: center;
    }
    img {
      // width: 16px;
      height: 16px;
      // margin-top: 3px;
    }
    .price {
      font-size: 20px;
      color: rgba(244, 69, 69, 1);
      // margin-left: 4px;
      // margin-right: 5px;
    }
    .add-btn {
      margin-left: auto;
      img {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        margin-top: 4px;
      }
    }
  }
  .goods-flag {
    // display: flex;
    height: 16px;
    overflow: hidden;
    padding: 5px 14px 0;
  }
  .goods-item-flag {
    // width: 34px;
    width: auto;
    min-width: 32px;
    height: 16px;
    margin-right: 6px;
    float: left;
  }
  .line-price-box {
    margin: 0 15px;
    width: fit-content;
    position: relative;
    display: flex;
    align-items: center;
    .fudou2 {
      width: 15px;
      height: 15px;
      margin-top: 0;
      vertical-align: middle;
      // -webkit-filter: grayscale(100%);
      // -moz-filter: grayscale(100%);
      // -ms-filter: grayscale(100%);
      // -o-filter: grayscale(100%);
      // filter: grayscale(100%);
      // filter: gray;
      // opacity: 0.7;
    }
    .line-price-num {
      font-size: 14px;
      text-decoration: line-through;
      margin-left: 0px;
      color: #999999;
    }
    // &:after {
    //   content: "";
    //   width: calc(100% - 10px);
    //   height: 1px;
    //   position: absolute;
    //   left: 12px;
    //   top: 10px;
    //   background-color: #999999;
    // }
  }
  .discountPriceWrap{
    padding: 0px 15px;
    margin-top: 6px;
  }
  .purple-icon {
    width: 14px;
    height: 14px;
    margin-left: 3px;
  }
  .multi-product {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 12px;
    margin-left: 3px;
    margin-top: 4px;
  }
  .detail-add-btn{
    width: 60px;
    height: 26px;
    line-height: 26px;
    background:#3FA6FF;
    background: var(--df-primary-color, #3FA6FF);
    border-radius: 2px;
    color: white;
    text-align: center;
    position: relative;
    cursor: pointer;
    top: -5px;
    margin-left: auto;
  }
  .fpp-style{
    padding: 0 15px;
    margin-top: 6px;
    font-weight: 400 !important;
  }
  .pad-15{
    padding: 0 15px;
  }

}
</style>
